<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :ok-disabled="disableSubmit"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    cancelText="关闭">
    <pre-employee-form ref="employeeModalForm" @ok="submitCallback" @handlerLastPage="handlerLastPage"  :disabled="disableSubmit"></pre-employee-form>
  </j-modal>
</template>

<script>

  import PreEmployeeForm from './PreEmployeeForm'
  import { deleteAction } from '@/api/manage'
  export default {
    name: 'PreEmployeeModel',
    components: {
      PreEmployeeForm
    },
    data () {
      return {
        title:'',
        width:1200,
        visible: false,
        disableSubmit: false,
        model:{},
      }
    },
    methods: {
      handlerLastPage(lastModel) {
        this.visible=false
        deleteAction('/prevent/customer/delete', {id: lastModel.customerId}).then((res) => {
            if (res.success) {
              this.$emit('handlerLastPage',lastModel)
            }
          })
      },
      setModel(model) {
        this.model = model
        console.log('PreEmployeeModel setModel : ',model)
        this.$nextTick(()=>{
          this.$refs.employeeModalForm.setModel(model);
        })
      },
      add () {
        this.visible=true
        this.$nextTick(()=>{
          console.log('PreCustomerModal  this.$refs.employeeModalForm : ', this.$refs.employeeModalForm)
          this.$refs.employeeModalForm.add();
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.employeeModalForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.visible = false;
        this.$emit('ok');

        this.$refs.employeeModalForm.submitForm();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
        deleteAction('/prevent/customer/delete', {id: this.model.customerId}).then((res) => {
            if (res.success) {
              this.$emit('ok');
            }
          })
      },
    }
  }
</script>